import { Box, Grid, Typography } from "@material-ui/core";
import ProductTag from "./productTagForm";

export default function ProductTagEditPage({ disabled, ...props }) {
  return (
    <>
      <Box width="100%">
        <Typography variant="h4" gutterBottom>
          eShop &gt; Edit Tag
        </Typography>
      </Box>
      <Grid container xs={6}>
        <ProductTag
          description="Edit Tag"
          submitBtnTxt="Save Changes"
          upperBtnGroupSize="50%"
          history={props.history}
          disabled={disabled}
        />
      </Grid>
    </>
  );
}
